(ns webapp.connections.dlp-info-types)

(def gcp-options
  ["ADVERTISING_ID"
   "AGE"
   "AMERICAN_BANKERS_CUSIP_ID"
   "ARGENTINA_DNI_NUMBER"
   "AUSTRALIA_DRIVERS_LICENSE_NUMBER"
   "AUSTRALIA_MEDICARE_NUMBER"
   "AUSTRALIA_PASSPORT"
   "AUSTRALIA_TAX_FILE_NUMBER"
   "AUTH_TOKEN"
   "AWS_CREDENTIALS"
   "AZURE_AUTH_TOKEN"
   "BASIC_AUTH_HEADER"
   "BELGIUM_NATIONAL_ID_CARD_NUMBER"
   "BRAZIL_CPF_NUMBER"
   "CANADA_BANK_ACCOUNT"
   "CANADA_BC_PHN"
   "CANADA_DRIVERS_LICENSE_NUMBER"
   "CANADA_OHIP"
   "CANADA_PASSPORT"
   "CANADA_QUEBEC_HIN"
   "CANADA_SOCIAL_INSURANCE_NUMBER"
   "CHILE_CDI_NUMBER"
   "CHINA_PASSPORT"
   "CHINA_RESIDENT_ID_NUMBER"
   "COLOMBIA_CDC_NUMBER"
   "COUNTRY_DEMOGRAPHIC"
   "CREDIT_CARD_NUMBER"
   "CREDIT_CARD_TRACK_NUMBER"
   "CROATIA_PERSONAL_ID_NUMBER"
   "DATE"
   "DATE_OF_BIRTH"
   "DENMARK_CPR_NUMBER"
   "DOCUMENT_TYPE/FINANCE/REGULATORY"
   "DOCUMENT_TYPE/FINANCE/SEC_FILING"
   "DOCUMENT_TYPE/HR/RESUME"
   "DOCUMENT_TYPE/LEGAL/BLANK_FORM"
   "DOCUMENT_TYPE/LEGAL/BRIEF"
   "DOCUMENT_TYPE/LEGAL/COURT_ORDER"
   "DOCUMENT_TYPE/LEGAL/LAW"
   "DOCUMENT_TYPE/LEGAL/PLEADING"
   "DOCUMENT_TYPE/R&D/DATABASE_BACKUP"
   "DOCUMENT_TYPE/R&D/PATENT"
   "DOCUMENT_TYPE/R&D/SOURCE_CODE"
   "DOCUMENT_TYPE/R&D/SYSTEM_LOG"
   "DOMAIN_NAME"
   "EMAIL_ADDRESS"
   "ENCRYPTION_KEY"
   "ETHNIC_GROUP"
   "FDA_CODE"
   "FEMALE_NAME"
   "FINLAND_NATIONAL_ID_NUMBER"
   "FIRST_NAME"
   "FRANCE_CNI"
   "FRANCE_NIR"
   "FRANCE_PASSPORT"
   "FRANCE_TAX_IDENTIFICATION_NUMBER"
   "GCP_API_KEY"
   "GCP_CREDENTIALS"
   "GENDER"
   "GENERIC_ID"
   "GERMANY_DRIVERS_LICENSE_NUMBER"
   "GERMANY_IDENTITY_CARD_NUMBER"
   "GERMANY_PASSPORT"
   "GERMANY_SCHUFA_ID"
   "GERMANY_TAXPAYER_IDENTIFICATION_NUMBER"
   "HONG_KONG_ID_NUMBER"
   "HTTP_COOKIE"
   "IBAN_CODE"
   "ICCID_NUMBER"
   "ICD10_CODE"
   "ICD9_CODE"
   "IMEI_HARDWARE_ID"
   "IMSI_ID"
   "INDIA_AADHAAR_INDIVIDUAL"
   "INDIA_GST_INDIVIDUAL"
   "INDIA_PAN_INDIVIDUAL"
   "INDONESIA_NIK_NUMBER"
   "IP_ADDRESS"
   "IRELAND_DRIVING_LICENSE_NUMBER"
   "IRELAND_EIRCODE"
   "IRELAND_PASSPORT"
   "IRELAND_PPSN"
   "ISRAEL_IDENTITY_CARD_NUMBER"
   "ITALY_FISCAL_CODE"
   "JAPAN_BANK_ACCOUNT"
   "JAPAN_DRIVERS_LICENSE_NUMBER"
   "JAPAN_INDIVIDUAL_NUMBER"
   "JAPAN_PASSPORT"
   "JSON_WEB_TOKEN"
   "KOREA_PASSPORT"
   "KOREA_RRN"
   "LAST_NAME"
   "LOCATION"
   "LOCATION_COORDINATES"
   "MAC_ADDRESS"
   "MAC_ADDRESS_LOCAL"
   "MALE_NAME"
   "MARITAL_STATUS"
   "MEDICAL_RECORD_NUMBER"
   "MEDICAL_TERM"
   "MEXICO_CURP_NUMBER"
   "MEXICO_PASSPORT"
   "NETHERLANDS_BSN_NUMBER"
   "NETHERLANDS_PASSPORT"
   "NEW_ZEALAND_IRD_NUMBER"
   "NORWAY_NI_NUMBER"
   "OAUTH_CLIENT_SECRET"
   "ORGANIZATION_NAME"
   "PARAGUAY_CIC_NUMBER"
   "PASSPORT"
   "PASSWORD"
   "PERU_DNI_NUMBER"
   "PERSON_NAME"
   "PHONE_NUMBER"
   "POLAND_NATIONAL_ID_NUMBER"
   "POLAND_PASSPORT"
   "POLAND_PESEL_NUMBER"
   "PORTUGAL_CDC_NUMBER"
   "PORTUGAL_NIB_NUMBER"
   "PORTUGAL_SOCIAL_SECURITY_NUMBER"
   "SCOTLAND_COMMUNITY_HEALTH_INDEX_NUMBER"
   "SINGAPORE_NATIONAL_REGISTRATION_ID_NUMBER"
   "SINGAPORE_PASSPORT"
   "SOUTH_AFRICA_ID_NUMBER"
   "SPAIN_CIF_NUMBER"
   "SPAIN_DNI_NUMBER"
   "SPAIN_DRIVERS_LICENSE_NUMBER"
   "SPAIN_NIE_NUMBER"
   "SPAIN_NIF_NUMBER"
   "SPAIN_PASSPORT"
   "SPAIN_SOCIAL_SECURITY_NUMBER"
   "SSL_CERTIFICATE"
   "STORAGE_SIGNED_POLICY_DOCUMENT"
   "STORAGE_SIGNED_URL"
   "STREET_ADDRESS"
   "SWEDEN_NATIONAL_ID_NUMBER"
   "SWEDEN_PASSPORT"
   "SWIFT_CODE"
   "TAIWAN_PASSPORT"
   "THAILAND_NATIONAL_ID_NUMBER"
   "TIME"
   "TURKEY_ID_NUMBER"
   "UK_DRIVERS_LICENSE_NUMBER"
   "UK_NATIONAL_HEALTH_SERVICE_NUMBER"
   "UK_NATIONAL_INSURANCE_NUMBER"
   "UK_PASSPORT"
   "UK_TAXPAYER_REFERENCE"
   "URL"
   "US_ADOPTION_TAXPAYER_IDENTIFICATION_NUMBER"
   "US_BANK_ROUTING_MICR"
   "US_DEA_NUMBER"
   "US_DRIVERS_LICENSE_NUMBER"
   "US_EMPLOYER_IDENTIFICATION_NUMBER"
   "US_HEALTHCARE_NPI"
   "US_INDIVIDUAL_TAXPAYER_IDENTIFICATION_NUMBER"
   "US_MEDICARE_BENEFICIARY_ID_NUMBER"
   "US_PASSPORT"
   "US_PREPARER_TAXPAYER_IDENTIFICATION_NUMBER"
   "US_SOCIAL_SECURITY_NUMBER"
   "US_STATE"
   "US_TOLLFREE_PHONE_NUMBER"
   "US_VEHICLE_IDENTIFICATION_NUMBER"
   "URUGUAY_CDI_NUMBER"
   "VAT_NUMBER"
   "VEHICLE_IDENTIFICATION_NUMBER"
   "VENEZUELA_CDI_NUMBER"
   "WEAK_PASSWORD_HASH"
   "XSRF_TOKEN"])

(def presidio-options
  ["CREDIT_CARD"
   "CRYPTO"
   "DATE_TIME"
   "EMAIL_ADDRESS"
   "IBAN_CODE"
   "IP_ADDRESS"
   "NRP"
   "LOCATION"
   "PERSON"
   "PHONE_NUMBER"
   "MEDICAL_LICENSE"
   "URL"
   "US_BANK_NUMBER"
   "US_DRIVER_LICENSE"
   "US_ITIN"
   "US_PASSPORT"
   "US_SSN"
   "UK_NHS"
   "UK_NINO"
   "ES_NIF"
   "ES_NIE"
   "IT_FISCAL_CODE"
   "IT_DRIVER_LICENSE"
   "IT_VAT_CODE"
   "IT_PASSPORT"
   "IT_IDENTITY_CARD"
   "PL_PESEL"
   "SG_NRIC_FIN"
   "SG_UEN"
   "AU_ABN"
   "AU_ACN"
   "AU_TFN"
   "AU_MEDICARE"
   "IN_PAN"
   "IN_AADHAAR"
   "IN_VEHICLE_REGISTRATION"
   "IN_VOTER"
   "IN_PASSPORT"
   "FI_PERSONAL_IDENTITY_CODE"])
